<template>
  <div class="box p-3">
    <div v-if="isAddressLoading" class="has-text-centered">
      <PulseLoader :loading="true" color="#00d1b2" size="12px"></PulseLoader>
    </div>
    <div v-else>
      <!-- Header with title and type selector -->
      <div class="columns is-multiline mb-2">
        <div class="column is-full">
          <div class="is-flex is-justify-content-space-between is-align-items-end">
            <div class="field">
              <label class="label is-small mb-0">Name</label>
              <div class="control">
                <input class="input is-small" v-model="DistributionZoneName" type="text" />
              </div>
            </div>
            <!-- Type selector in header that syncs with details tab -->
            <div class="field">
              <label class="label is-small mb-0">Type</label>
              <div class="control">
                <div class="select is-small">
                  <select v-model="DistributionZoneType">
                    <option v-for="type in store.getters.DistributionZoneTypes" :key="type.value" :value="type">
                      {{ type.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main content in tabs -->
      <div class="tabs is-small is-success mb-2">
        <ul>
          <li :class="{ 'is-active': activeTab === 'location' }">
            <a @click="activeTab = 'location'">Location</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'" :class="{ 'is-active': activeTab === 'details' }">
            <a @click="activeTab = 'details'">Details</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'" :class="{ 'is-active': activeTab === 'features' }">
            <a @click="activeTab = 'features'">Features</a>
          </li>
          <li v-if="DistributionZoneType.label !== 'CENTER ZONE'"
            :class="{ 'is-active': activeTab === 'daysOfService' }">
            <a @click="activeTab = 'daysOfService'">Days of Service</a>
          </li>
        </ul>
      </div>

      <!-- Tab content container with fixed height -->
      <div class="tab-content-container">
        <!-- Location Tab -->
        <div v-if="activeTab === 'location'" class="tab-content">
          <div class="columns is-multiline is-mobile">
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Region</label>
                <div class="control">
                  <div class="select is-small is-fullwidth">
                    <select v-model="Region.id">
                      <option v-for="region in store.state.regions" :key="region.id" :value="region.id">
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Search Address</label>
                <div class="control">
                  <input class="input is-small" type="text" ref="autocomplete" placeholder="Enter a location"
                    @focus="onInputFocus" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Coordinates (Lat/Lng)</label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <input class="input is-small" v-model.number="Latitude" type="number"
                      :disabled="geocoding_loading" />
                  </div>
                  <div class="control is-expanded">
                    <input class="input is-small" v-model.number="Longitude" type="number"
                      :disabled="geocoding_loading" />
                  </div>
                  <div class="control">
                    <button class="button is-small  is-borderless" @click="getCoordinates"
                      :class="{ 'is-loading': geocoding_loading || loading }">
                      Get
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Country</label>
                    <div class="control">
                      <div class="select is-small is-fullwidth">
                        <select v-model="Country">
                          <option v-for="country in store.getters.Countries" :key="country.value" :value="country">
                            {{ country.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Province</label>
                    <div class="control">
                      <div class="select is-small is-fullwidth">
                        <select v-model="Province">
                          <option v-for="province in store.getters.TaxProvinces" :key="province.Province"
                            :value="province.Province">
                            {{ province.Province }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">City</label>
                    <div class="control">
                      <input class="input is-small" v-model="City" type="text" />
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Postal Code</label>
                    <div class="control">
                      <input class="input is-small" v-model="PostalCode" type="text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="columns is-mobile">
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Door Number</label>
                    <div class="control">
                      <input class="input is-small" v-model="DoorNumber" type="text" />
                    </div>
                  </div>
                </div>
                <div class="column is-half">
                  <div class="field">
                    <label class="label is-small mb-0">Apartment</label>
                    <div class="control">
                      <input class="input is-small" v-model="Apartment" type="text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Street</label>
                <div class="control">
                  <input class="input is-small" v-model="Street" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Details Tab -->
        <div v-if="activeTab === 'details'" class="tab-content">
          <div class="columns is-multiline is-mobile">
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Facility</label>
                <div class="control">
                  <div class="select is-fullwidth is-small">
                    <select v-model="Facility">
                      <option v-for="type in store.getters.Facility" :key="type" :value="type">
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half" v-if="DistributionZoneType.label === 'STORE'">
              <div class="field">
                <label class="label is-small mb-0">Client</label>
                <div class="control">
                  <div class="select is-fullwidth is-small">
                    <select v-model="Vendor">
                      <option v-for="vendor in store.state.vendors" :key="vendor.Id" :value="vendor.Id">
                        {{ vendor.businessUnit }}***{{ vendor.subBusinessUnit }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Phone</label>
                <div class="control">
                  <input class="input is-small" v-model="PhoneNumber" type="tel" placeholder="xxxxxxxxxx" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Size (Sq. Ft.)</label>
                <div class="control">
                  <input class="input is-small" v-model.number="Size" type="number" />
                </div>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label is-small mb-0">Number Of Employees</label>
                <div class="control">
                  <input class="input is-small" v-model.number="NumberOfEmployees" type="number" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Features Tab -->
        <div v-if="activeTab === 'features'" class="tab-content">
          <div class="field mb-3">
            <label class="label is-small mb-2">Distribution Zone Features</label>
            <div class="tags">
              <span class="tag is-small" :class="{ 'is-primary': IsFinalMile, 'is-light': !IsFinalMile }"
                @click="IsFinalMile = !IsFinalMile">
                Final Mile
              </span>
              <span class="tag is-small" :class="{
                'is-primary': IsForReverse,
                'is-light': !IsForReverse,
              }" @click="IsForReverse = !IsForReverse">
                Reverse Logistics
              </span>
              <span class="tag is-small" :class="{
                'is-primary': AllowCrossdock,
                'is-light': !AllowCrossdock,
              }" @click="AllowCrossdock = !AllowCrossdock">
                Crossdock
              </span>
              <span class="tag is-small" :class="{
                'is-primary': AllowOvernightReception,
                'is-light': !AllowOvernightReception,
              }" @click="AllowOvernightReception = !AllowOvernightReception">
                Overnight Reception
              </span>
              <span class="tag is-small" :class="{
                'is-primary': CustomFields.shouldConsiderFuelSurcharge,
                'is-light': !CustomFields.shouldConsiderFuelSurcharge,
              }" @click="
                CustomFields.shouldConsiderFuelSurcharge =
                !CustomFields.shouldConsiderFuelSurcharge
                ">
                Fuel Surcharge
              </span>
            </div>
          </div>

          <div class="field mb-3">
            <label class="label is-small mb-2">Data Source</label>
            <div class="tags">
              <span class="tag is-small" :class="{
                'is-success': CustomFields.IsCDSRegion,
                'is-light': !CustomFields.IsCDSRegion,
              }" @click="CustomFields.IsCDSRegion = !CustomFields.IsCDSRegion">
                Shyftbase
              </span>
              <span class="tag is-small" :class="{
                'is-success': CustomFields.IsCustomerRegion,
                'is-light': !CustomFields.IsCustomerRegion,
              }" @click="
                CustomFields.IsCustomerRegion = !CustomFields.IsCustomerRegion
                ">
                External
              </span>
            </div>
          </div>
        </div>

        <!-- Days of Service Tab -->
        <div v-if="activeTab === 'daysOfService'" class="tab-content">
          <div class="field mb-3">
            <label class="label is-small mb-2">Select Days of Service</label>
            <div class="tags">
              <span v-for="day in daysOfWeek" :key="day.value" class="tag is-small" :class="{
                'is-primary': daysOfService[day.value],
                'is-light': !daysOfService[day.value],
              }" @click="toggleDay(day.value)">
                {{ day.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <div class="notification m-0 p-2" style="background-color: white">
            <div class="is-size-7 has-text-danger">
              {{ msg || err_message }}
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="field is-grouped is-grouped-right m-0">
            <p class="control m-1">
              <button @click="removeHub" class="button is-small is-danger"
                :class="{ 'is-loading': isSaving || geocoding_loading }" style="border-radius: 5px"
                :disabled="isSaving">
                Remove
              </button>
            </p>
            <p class="control m-1">
              <button @click="saveToFirestore" class="button is-small is-primary"
                :class="{ 'is-loading': isSaving || geocoding_loading }" style="border-radius: 5px"
                :disabled="isSaving">
                Save
              </button>
            </p>
            <p class="control m-1">
              <button @click="reset" class="button is-small is-light" :disabled="isSaving" style="border-radius: 5px">
                Reset
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { hubsCollection, firestoreInstance, zonesInfoCollection } from "../store/fireStore";
import { find, updateOne } from "../store/mongoStore";
import EventHandler from "../EventHandler";
import axios from "axios";
import * as leafletPip from "@mapbox/leaflet-pip";
import { geoJsonFeature } from "../views/utils";
import { circle as circleTurf } from "@turf/turf";

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      activeTab: "location",
      isSaving: false,
      clientName: process.env.VUE_APP_SHYFTBASE_CUSTOMER_ID,
      Color: this.DistributionZone.Color || "#EEE",
      DistributionZoneName: this.DistributionZone.DistributionZoneName || "",
      DistributionZoneId: this.DistributionZone.DistributionZoneId || "",
      Street: this.DistributionZone.Street || "",
      DoorNumber: this.DistributionZone.DoorNumber || "",
      Apartment: this.DistributionZone.Apartment || "",
      City: this.DistributionZone.City || "",
      Province: this.store.getters.TaxProvinces.find(
        (province) => province.Province === this.DistributionZone.Province
      )
        ? this.DistributionZone.Province
        : "",
      PostalCode: this.DistributionZone.PostalCode || "",
      DistributionZoneType:
        this.store.getters.DistributionZoneTypes.find(
          (type) => type.value === this.DistributionZone.DistributionZoneType
        ) || null,
      Facility: this.DistributionZone.Facility || "WAREHOUSE",
      Size: this.DistributionZone.Size || 0,
      NumberOfEmployees: this.DistributionZone.NumberOfEmployees || 0,
      PhoneNumber: this.DistributionZone.PhoneNumber || "",
      Vendor: this.DistributionZone.Vendor || "",
      AllowCrossdock: this.DistributionZone.AllowCrossdock || false,
      IsFinalMile: this.DistributionZone.IsFinalMile || false,
      IsForReverse: this.DistributionZone.IsForReverse || false,
      CustomFields: {
        IsCDSRegion: this.DistributionZone.CustomFields.IsCDSRegion || false,
        IsCustomerRegion:
          this.DistributionZone.CustomFields.IsCustomerRegion || false,
        shouldConsiderFuelSurcharge:
          this.DistributionZone.CustomFields.shouldConsiderFuelSurcharge ||
          false,
      },
      AllowOvernightReception:
        this.DistributionZone.AllowOvernightReception || false,
      loading: false,
      msg: "",
      Region: {
        name: "",
        id: this.DistributionZone.Region,
      },
      Latitude: this.coordinates
        ? this.coordinates.lat
        : this.DistributionZone.Center.latitude || 0,
      Longitude: this.coordinates
        ? this.coordinates.lng
        : this.DistributionZone.Center.longitude || 0,
      err_message: "",
      geocoding_loading: false,
      TimeZone: this.timeZone,
      Country: {
        label: this.DistributionZone.Country || "",
        value: this.DistributionZone.CountryCode || "",
      },
      isAddressLoading: false,
      daysOfWeek: [
        { label: "Monday", value: "monday" },
        { label: "Tuesday", value: "tuesday" },
        { label: "Wednesday", value: "wednesday" },
        { label: "Thursday", value: "thursday" },
        { label: "Friday", value: "friday" },
        { label: "Saturday", value: "saturday" },
        { label: "Sunday", value: "sunday" },
      ],
      daysOfService: this.DistributionZone.DaysOfService || {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
    };
  },
  props: {
    store: {
      type: Object,
    },
    map: {
      type: Object,
    },
    DistributionZone: {
      type: Object,
    },
    editable: {
      type: Boolean,
    },
    coordinates: {
      type: Object,
    },
    timeZone: {
      type: String,
    },
    fromTable: {
      type: Boolean,
    },
    closeModal: {
      type: Function,
    },
  },
  computed: {
    getDistributionZoneType() {
      return this.store.getters.DistributionZoneTypes;
    },
  },
  watch: {
    DistributionZoneType: function (val) {
      // Switch to location tab when CENTER ZONE is selected
      if (val && val.label === "CENTER ZONE") {
        this.activeTab = "location";
      }

      // Emit type change to update marker icon
      this.$emit('type-change', {
        type: val?.label || 'DEFAULT',
        color: this.Color
      });
    },
    Latitude(newVal) {
      this.emitCoordinateChange();
    },
    Longitude(newVal) {
      this.emitCoordinateChange();
    },
    activeTab(newVal) {
      if (newVal === "location") {
        // Wait for the DOM to update before initializing autocomplete
        this.$nextTick(() => {
          this.initializeGoogleAutocomplete();
        });
      }
    },
  },
  methods: {
    onInputFocus() {
      // Only initialize if not already initialized
      if (!this.autocomplete) {
        this.initializeGoogleAutocomplete();
      }
    },
    close() {
      // Clean up Google autocomplete when modal closes
      this.cleanupGoogleAutocomplete();
      if (!this.fromTable) {
        EventHandler.$emit("close");
      } else {
        this.closeModal();
      }
    },
    // Add cleanup method for Google autocomplete
    cleanupGoogleAutocomplete() {
      // Remove autocomplete listeners if they exist
      if (this.autocomplete) {
        window.google.maps.event.clearInstanceListeners(this.autocomplete);
        this.autocomplete = null;
      }

      // Remove all pac-container elements from the document
      const pacContainers = document.querySelectorAll(".pac-container");
      pacContainers.forEach((container) => {
        container.remove();
      });

      // Clear the input if needed
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.blur(); // Remove focus
      }
    },
    removeZone() {
      EventHandler.$emit("remove");
    },
    reset() {
      this.Color = this.DistributionZone.Color || "#EEE";
      this.DistributionZoneName =
        this.DistributionZone.DistributionZoneName || "";
      this.DistributionZoneId = this.DistributionZone.DistributionZoneId || "";
      this.Street = this.DistributionZone.Street || "";
      this.DoorNumber = this.DistributionZone.DoorNumber || "";
      this.Apartment = this.DistributionZone.Apartment || "";
      this.City = this.DistributionZone.City || "";
      this.Province = this.DistributionZone.Province || "";
      this.PostalCode = this.DistributionZone.PostalCode || "";
      this.DistributionZoneType =
        this.store.getters.DistributionZoneTypes.find(
          (type) => type.value === this.DistributionZone.DistributionZoneType
        ) || null;
      this.Facility = this.DistributionZone.Facility || "WAREHOUSE";
      this.Size = this.DistributionZone.Size || 0;
      this.NumberOfEmployees = this.DistributionZone.NumberOfEmployees || 0;
      this.PhoneNumber = this.DistributionZone.PhoneNumber || "";
      this.Vendor = this.DistributionZone.Vendor || "";
      this.AllowCrossdock = this.DistributionZone.AllowCrossdock || false;
      this.IsFinalMile = this.DistributionZone.IsFinalMile || false;
      this.IsForReverse = this.DistributionZone.IsForReverse || false;
      this.CustomFields = {
        IsCDSRegion: this.DistributionZone.CustomFields.IsCDSRegion || false,
        IsCustomerRegion:
          this.DistributionZone.CustomFields.IsCustomerRegion || false,
        shouldConsiderFuelSurcharge:
          this.DistributionZone.CustomFields.shouldConsiderFuelSurcharge ||
          false,
      };
      this.AllowOvernightReception =
        this.DistributionZone.AllowOvernightReception || false;
      this.Latitude = this.DistributionZone.Center.latitude;
      this.Longitude = this.DistributionZone.Center.longitude;
      this.TimeZone = this.timeZone;
      this.Country = {
        label: this.DistributionZone.Country || "",
        value: this.DistributionZone.CountryCode || "",
      };
      this.daysOfService = this.DistributionZone.DaysOfService || {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      };
    },
    async removeHub() {
      this.isSaving = true;
      try {
        await hubsCollection.doc(this.DistributionZoneId).delete();
        this.isSaving = false;

        if (!this.fromTable) {
          EventHandler.$emit("close");
        } else {
          this.closeModal();
        }

        this.$notify({
          group: "zones",
          type: "success",
          title: "Distribution Zone deleted",
          text: `Distribution Zone ${this.DistributionZoneName} was deleted successfully`,
          duration: 3000,
        });
      } catch (error) {
        console.error("Error removing hub:", error);
        this.isSaving = false;
        // Add error notification
        this.$notify({
          group: "zones",
          type: "error",
          title: "Error deleting distribution zone",
          text: "Something went wrong, please try again.",
          duration: 3000,
        });
      }
    },
    emitCoordinateChange() {
      this.$emit("coordinate-change", {
        lat: this.Latitude,
        lng: this.Longitude,
      });
    },
    async saveToFirestore() {
      this.isSaving = true;
      const {
        DistributionZoneId,
        Street,
        DoorNumber,
        Apartment,
        City,
        Province,
        PostalCode,
        DistributionZoneType,
        Facility,
        Size,
        NumberOfEmployees,
        PhoneNumber,
        AllowCrossdock,
        IsFinalMile,
        IsForReverse,
        CustomFields,
        AllowOvernightReception,
        Vendor,
        Color,
        Region,
        Latitude,
        Longitude,
        TimeZone,
        Country,
        daysOfService,
      } = this;
      if (Vendor === "" && DistributionZoneType.label === "STORE") {
        this.msg = "Please Select a Client";
        this.isSaving = false;
        return;
      }

      const Center = new firestoreInstance.GeoPoint(
        parseFloat(String(Latitude)),
        parseFloat(String(Longitude))
      );

      // Check if center location has changed
      const oldCenter = this.DistributionZone.Center;
      const centerChanged = oldCenter && (
        oldCenter.latitude !== parseFloat(String(Latitude)) ||
        oldCenter.longitude !== parseFloat(String(Longitude))
      );

      if (Street && City && Province && PostalCode && Country.label) {
        await hubsCollection
          .doc(this.DistributionZone.DistributionZoneId)
          .set(
            {
              Street,
              DoorNumber,
              Apartment,
              City,
              Province,
              PostalCode,
              AllowCrossdock,
              IsFinalMile,
              IsForReverse,
              CustomFields,
              AllowOvernightReception,
              DistributionZoneType: DistributionZoneType.value,
              Facility,
              Size,
              NumberOfEmployees,
              PhoneNumber,
              Color,
              Vendor: DistributionZoneType.label === "STORE" ? Vendor : "",
              Region: Region.id,
              Center,
              TimeZone,
              Country: Country.label,
              CountryCode: Country.value,
              DaysOfService: daysOfService,
            },
            { merge: true }
          )
          .then(async () => {
            // If center location changed, update distance zone shapes
            if (centerChanged) {
              try {
                const newCenter = {
                  _lat: parseFloat(String(Latitude)),
                  _long: parseFloat(String(Longitude))
                };

                await this.updateDistanceZoneShapes(
                  this.DistributionZone.DistributionZoneId,
                  newCenter
                );

                // Add notification for distance zone updates
                this.$notify({
                  group: "zones",
                  type: "info",
                  title: "Distance zones updated",
                  text: "Distance zone shapes have been updated with the new center location",
                  duration: 3000,
                });
              } catch (error) {
                console.error('Error updating distance zone shapes:', error);
                // Don't fail the entire operation, just log the error
              }
            }

            this.loading = false;
            this.close();
            if (!this.fromTable) {
              this.map.panTo([Latitude, Longitude]);
            }
            this.msg = "";
            this.isSaving = false;
            // Add notification
            this.$notify({
              group: "zones",
              type: "success",
              title: "Distribution zone updated",
              text: `Distribution zone ${this.DistributionZoneName} was updated successfully`,
              duration: 3000,
            });
          })
          .catch((err) => {
            console.error("error", err);
            this.isSaving = false;
            // Add error notification
            this.$notify({
              group: "zones",
              type: "error",
              title: "Error updating distribution zone",
              text: "Something went wrong, please try again.",
              duration: 3000,
            });
          });
      } else {
        this.msg = "Name, street, city, province and postal code are required";
        this.isSaving = false;
      }
    },
    async getAddressFromCoordinates() {
      this.isAddressLoading = true;
      const { lat, lng } = this.coordinates;
      const url = process.env.VUE_APP_REVERSE_GEOCODE;

      try {
        const response = await axios.post(url, {
          data: {
            latitude: lat,
            longitude: lng,
          },
        });
        const {
          countryCode,
          countryName,
          state,
          city,
          street,
          postalCode,
          houseNumber,
        } = response.data;

        this.Street = street || "";
        this.DoorNumber = houseNumber || "";
        this.City = city || "";

        // Add province validation here too
        const taxProvince = this.store.getters.TaxProvinces.find(
          (province) => province.Province === state
        );
        this.Province = taxProvince ? taxProvince.Province : "";

        this.PostalCode = postalCode || "";
        this.Country = {
          label: countryName || "",
          value: countryCode || "",
        };

        this.loading = false;
      } catch (error) {
        console.error("Error fetching address:", error);
        this.loading = false;
      } finally {
        this.isAddressLoading = false;
        this.$nextTick(() => {
          this.initializeGoogleAutocomplete();
        });
      }
    },
    initializeGoogleAutocomplete() {
      const input = this.$refs.autocomplete;
      if (
        input &&
        window.google &&
        window.google.maps &&
        window.google.maps.places
      ) {
        // Clean up existing autocomplete instance if it exists
        if (this.autocomplete) {
          // Remove existing listeners to prevent memory leaks
          window.google.maps.event.clearInstanceListeners(this.autocomplete);
        }

        const options = {
          types: [], // Restrict to addresses: https://developers.google.com/maps/documentation/javascript/supported_types
        };
        this.autocomplete = new window.google.maps.places.Autocomplete(
          input,
          options
        );
        this.autocomplete.addListener("place_changed", this.onPlaceChanged);
      } else {
        console.error("Google Maps API not loaded");
      }
    },
    async getCoordinates() {
      const { Street, City, PostalCode, Province, Country } = this;

      this.geocoding_loading = true;
      const geocode_url =
        "https://us-central1-core-v2-34762.cloudfunctions.net/GEOCODE-functions-getOptimizerGeocode";
      const geocode_data = [
        {
          address:
            Street + " " + City + " " + Province ||
            "" + " " + Country.label ||
            "" + " " + PostalCode,
        },
      ];
      if (!Street || !PostalCode || !Province || !Country.label) {
        this.geocoding_loading = false;
        this.err_message = "Please enter a valid address";
        return;
      }
      await axios
        .post(geocode_url, { data: geocode_data })
        .then((response) => {
          this.geocoding_loading = false;
          if (response.data && response.data[0].geocodes) {
            const lat = response.data[0].geocodes.lat;
            const long = response.data[0].geocodes.long;

            this.Latitude = lat;
            this.Longitude = long;

            const gjLayer = window.L.geoJson(JSON.parse(geoJsonFeature));
            const firstPointResult = leafletPip.pointInLayer(
              [long, lat],
              gjLayer
            );
            this.TimeZone =
              firstPointResult[0].feature.properties.tz_name1st || "";
          } else {
            this.err_message =
              "Coordinates not found. Please check the address or you can manually enter the coordinates";
          }
        })
        .catch((error) => {
          console.error("geocoding error: ", error);
          this.geocoding_loading = false;
          this.err_message = "Internal error. Please contact Shyftbase team";
        });
      this.geocoding_loading = false;
    },
    async onPlaceChanged() {
      this.err_message = "";
      const addressObject = this.autocomplete.getPlace();
      const address = addressObject.address_components;

      const province = address
        ? address.filter((address_component) =>
          ["administrative_area_level_1"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;

      const streetAddress = address
        ? address
          .filter((address_component) =>
            [
              "floor",
              "room",
              "route",
              "street_number",
              "street_address",
            ].some((word) => address_component.types.includes(word))
          )
          .map((a) => a.short_name)
          .join(" ")
        : null;

      const city = address
        ? address.filter((address_component) =>
          ["locality", "colloquial_area"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;

      const postalCode = address
        ? address.filter((address_component) =>
          ["postal_code"].some((word) =>
            address_component.types.includes(word)
          )
        )
        : null;
      const country = address
        ? address.filter((address_component) =>
          ["country"].some((word) => address_component.types.includes(word))
        )
        : null;

      const _street = streetAddress;
      const _city = city.length && city[0] ? city[0].long_name : "";
      const _postalCode = postalCode.length
        ? postalCode[0].short_name || ""
        : "";

      const _country = country.length ? country[0].long_name : "";
      const _countryCode = country.length ? country[0].short_name : "";
      const _province = province.length ? province[0].long_name : this.Province;

      this.Street = _street;
      this.City = _city;
      this.PostalCode = _postalCode;
      this.Country = {
        label: _country,
        value: _countryCode,
      };
      this.Province = _province;

      // Add province validation similar to AddMarkerZoneModal
      const taxProvince = this.store.getters.TaxProvinces.find(
        (province) => province.Province === _province
      );
      this.Province = taxProvince ? taxProvince.Province : "";

      await this.getCoordinates();

      // After getting coordinates, ensure the autocomplete is still active
      this.$nextTick(() => {
        // Focus back on the input to allow continued autocomplete usage if needed
        if (this.$refs.autocomplete) {
          // Only set the value, don't blur or remove containers
          this.$refs.autocomplete.value = this.Street;
        }
      });
    },
    toggleDay(day) {
      this.daysOfService[day] = !this.daysOfService[day];
    },
    /**
     * Generate shape coordinates for distance-based zones
     * @param {Object} centerLocation - Center location object with coordinates
     * @param {Number} maxKm - Maximum radius in kilometers
     * @param {Number} minKm - Minimum radius in kilometers (optional)
     * @returns {Object} Object containing coordinates and multi flag
     */
    generateDistanceZoneShape(centerLocation, maxKm, minKm = 0) {
      if (!centerLocation?.Center?._lat || !centerLocation?.Center?._long) {
        throw new Error('Invalid center location coordinates');
      }

      const center = [centerLocation.Center._long, centerLocation.Center._lat];

      // Create the outer circle with max radius
      const outerCircle = circleTurf(center, maxKm, { steps: 64, units: 'kilometers' });

      // If minKm is 0 or not provided, return the outer circle
      if (!minKm || minKm <= 0) {
        return {
          coordinates: outerCircle.geometry.coordinates[0],
          multi: false
        };
      }

      // If minKm is provided, create a donut shape by subtracting the inner circle
      const innerCircle = circleTurf(center, minKm, { steps: 64, units: 'kilometers' });

      // Use turf difference to create the donut shape
      const donut = {
        type: "Polygon",
        coordinates: [
          outerCircle.geometry.coordinates[0], // outer ring
          innerCircle.geometry.coordinates[0].slice().reverse(), // inner ring (hole)
        ],
      };

      return {
        coordinates: donut.coordinates,
        multi: true,
      };
    },
    /**
     * Update distance zone shapes when center location changes
     * @param {string} distributionZoneId - The distribution zone ID that was updated
     * @param {Object} newCenter - New center coordinates
     */
    async updateDistanceZoneShapes(distributionZoneId, newCenter) {
      try {
        // Find all MongoDB documents with the same distributionZoneId
        const shapes = await find("zones", {
          distributionZoneId: distributionZoneId,
          type: 'distance'
        });

        if (shapes.length === 0) {
          return;
        }

        // Update each shape with new coordinates
        const updatePromises = shapes.map(async (shape) => {
          try {
            // Get the zone info to get min/max values
            const zoneDoc = await zonesInfoCollection.doc(shape.shapesID).get();
            const zoneData = zoneDoc.data();

            if (!zoneData) {
              console.warn('Zone data not found for shape:', shape.shapesID);
              return;
            }

            // Generate new shape coordinates with updated center
            const shapeData = this.generateDistanceZoneShape(
              { Center: newCenter },
              Number(zoneData.max),
              Number(zoneData.min)
            );

            // Update the shape coordinates in MongoDB
            await updateOne(
              "zones",
              { _id: shape._id },
              {
                $set: {
                  coordinates: JSON.stringify(shapeData.coordinates),
                  multi: shapeData.multi,
                }
              }
            );
          } catch (error) {
            console.error('Error updating shape:', shape.shapesID, error);
          }
        });

        await Promise.all(updatePromises);

        // Update center coordinates in Firestore zones collection
        await this.updateZoneCentersInFirestore(distributionZoneId, newCenter);
      } catch (error) {
        console.error('Error updating distance zone shapes:', error);
      }
    },
    /**
     * Update center coordinates in Firestore zones collection
     * @param {string} distributionZoneId - The distribution zone ID
     * @param {Object} newCenter - New center coordinates
     */
    async updateZoneCentersInFirestore(distributionZoneId, newCenter) {
      try {
        // Get all zones and filter those that have this center in their centers array
        const zonesSnapshot = await zonesInfoCollection.get();

        const zonesToUpdate = zonesSnapshot.docs.filter(doc => {
          const zoneData = doc.data();
          const centers = zoneData.centers || [];
          return centers.some(center => center.id === distributionZoneId);
        });

        if (zonesToUpdate.length === 0) {
          return;
        }

        const updatePromises = zonesToUpdate.map(async (doc) => {
          const zoneData = doc.data();
          const centers = zoneData.centers || [];

          // Find and update the center with matching ID
          const centerIndex = centers.findIndex(c => c.id === distributionZoneId);
          if (centerIndex >= 0) {
            centers[centerIndex] = {
              id: distributionZoneId,
              coordinates: newCenter
            };

            // Update the zone document
            await zonesInfoCollection.doc(doc.id).update({
              // Also update the single center field for backward compatibility
              center: centers
            });
          }
        });

        await Promise.all(updatePromises);
      } catch (error) {
        console.error('Error updating center coordinates in Firestore:', error);
      }
    },
  },
  mounted() {
    const regions = this.store.state.regions;
    // const currentRegionSelected = this.store.state.region;
    const selectedRegion = regions.find(
      (region) => region.id === this.Region.id
    );
    this.Region.name = selectedRegion ? selectedRegion.name : "";

    this.Latitude = this.coordinates.lat;
    this.Longitude = this.coordinates.lng;
    this.TimeZone = this.timeZone;
    this.err_message = "";
  },
};
</script>
<style lang="scss" scoped>
@import "~leaflet/dist/leaflet.css";

.custom .leaflet-popup-tip,
.custom .leaflet-popup-content-wrapper {
  color: #ffffff;
}

select,
.select {
  width: 100%;
}

.box {
  padding: 1rem;
  margin-right: 0;
  width: 100%;
  max-width: none;
  box-shadow: none;
}

/* Target the modal container if it's using Bulma's modal class */
.modal-content,
.modal-card {
  margin: 0 auto;
  max-width: 100%;
}

/* Style for the tabs */
.tabs.is-success {
  li.is-active a {
    border-bottom-color: #007d6a;
    color: #007d6a;
    font-weight: 600;
  }

  a {
    &:hover {
      border-bottom-color: var(--primary);
      color: var(--primary);
    }
  }

  li a {
    color: var(--primary);
  }
}

/* Fixed height container for tab content */
.tab-content-container {
  min-height: 280px;
  position: relative;
}

.tab-content {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

/* Header field alignment styles */
.field {
  margin-bottom: 0;
}

.field .label {
  margin-bottom: 0.25rem;
}

.field .control {
  margin-bottom: 0;
}

/* Ensure consistent heights for header inputs and selects */
.field .input.is-small,
.field .select.is-small {
  height: 2.25rem;
  line-height: 1.5;
}
</style>
